export const battlecardBuilderSchema = {
  type: "array",
  items: {
    type: "object",
    properties: {
      Name: { type: "string" },
      ParentName: { type: "string", nullable: true },
      Type: { type: "string" },
      LocalCurrency: { type: "string" },
      OwnerID: { type: "string", nullable: true },
    },
    required: ["Name", "ParentName", "Type", "LocalCurrency"],
    additionalProperties: false,
  },
};

export const battlecardTerritoryGroupTypesSchema = {
  type: "array",
  items: {
    type: "object",
    properties: {
      BattlecardName: { type: "string" },
      TerritoryGroupType: {
        type: "string",
      },
      Alias: { type: "string", nullable: true },
      OwnerID: { type: "string", nullable: true },
      Precedence: { type: "number", nullable: false },
    },
    required: ["BattlecardName", "TerritoryGroupType"],
    additionalProperties: false,
  },
};

export const quotaComponentsSchema = {
  type: "array",
  items: {
    properties: {
      QuotaComponent: {
        type: "string",
      },
    },
    additionalProperties: false,
    required: ["QuotaComponent"],
  },
};

export const qcAssignmentSchema = {
  type: "array",
  items: {
    type: "object",
    properties: {
      QuotaComponent: {
        type: "string",
      },
      BattlecardName: {
        type: "string",
      },
    },
    required: ["QuotaComponent", "BattlecardName"],
    additionalProperties: false,
  },
};

export const tgSchema = {
  type: "array",
  items: {
    type: "object",
    properties: {
      TerritoryGroupName: {
        type: "string",
      },
      Parent: { type: "string", nullable: true },
      BattlecardName: { type: "string", nullable: true },
      OwnerID: { type: "string", nullable: true },
    },
    required: ["TerritoryGroupName", "Parent", "BattlecardName"],
  },
};
